// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c608106b","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};